export default __webpack_public_path__ + "static/media/footer-brand-logos.8f050fce.svg";